'use strict'

export const buildMiiEmailResponse = {
  success: {
    title: 'Email sent successfully!',
    message: 'Please check your email to download the job description'
  },
  fail: {
    title: 'Email sent failed!',
    message: 'Failed to send email! Please try again'
  },
  default: {
    title: 'Something went wrong!',
    message: 'Something went wrong! Please contact your administrator'
  }
}

export const buildMiiLinks = {
  scheduleACall: "https://meetings.hubspot.com/catcaballero/website-booking-page",
  webflowHome: "https://meetings.hubspot.com/catcaballero/website-booking-page",
  salaryGuide: "https://www.multiplymii.com/salary-guide"
}

export const  buildMiiDescriptions = {
    label:'Multiply your business by attracting the right talent!',
    description:'Start your search by writing a good job description. We’ll help you get it right from the start with our AI-powered Job Description Builder!',
    description2: 'All you need is 10 minutes for 6 questions.',
    header: 'BuildMii a Job Description',
}

export const buildMiiPrompts = {
    entryPrompt: 'ChatGPT you are a Hiring Manager with extensive experience.\nYou have been provided with the following information:\n\n'
}

export const buildMiiPagesConfig = {
    pages: [
        {
            id:1,
            title:"Let's start with the job title.",
            pageGroupId:1
        },
        {
            id:2,
            title:"Tell us more about this",
            pageGroupId:2
        },
        {
            id:3,
            title:"Lastly, what qualities are you looking for in a/an",
            pageGroupId:3
        }
    ],
    maxPages: 3,
}

export const buildMiiStaticJobDescription = {
  description : "\nJob Title: Tester\n\nRole:\n\nThe Tester will be responsible for testing software applications and ensuring that they meet quality standards. \n\nResponsibilities:\n\n•\tReview and analyze system specifications\n•\tCollaborate with Quality Assurance Engineers to develop effective strategies and test plans\n•\tExecute test cases (manual or automated) and analyze results\n•\tEvaluate product code according to specifications\n•\tCreate logs to document testing phases and defects\n•\tReport bugs and errors to development teams\n•\tHelp troubleshoot issues\n•\tConduct post-release/ post-implementation testing\n•\tWork with cross-functional teams to ensure quality throughout the software development lifecycle\n•\t Stay up-to-date with new testing tools and test strategies\n\nResults:\n\n•\tEnsure all software applications are working correctly\n•\tIdentify and document bugs and errors\n•\tDevelop effective strategies for testing\n•\tCollaborate with cross-functional teams\n•\tContribute to successful product releases\n\nRequirements: \n\n•\tProven experience in software testing\n•\tKnowledge of software QA methodologies, tools and processes\n•\tFamiliarity with Agile frameworks and regression testing\n•\tAbility to document and troubleshoot errors\n•\tAttention to detail\n•\tCreative thinking ability\n•\tDecision-making ability\n•\tGoal-oriented mindset"
}

export const salaryGuide = {
    accountingFinance:{
      accountant:{
        phSalary:{
          yearOneTwo: 800,
          yearThreeFive: 1200,
          yearFivePlus:1800
        },
        usSalary:{
          yearOneFivePlus: {
            range1: 2900,
            range2: 10500
          }
        },
        estimatedCostSavings: '73%'
      },
      accountsPayReceive:{
        phSalary:{
          yearOneTwo: 650,
          yearThreeFive: 750,
          yearFivePlus:1000
        },
        usSalary:{
          yearOneFivePlus: {
            range1: 3000,
            range2: 7000
          }
        },
        estimatedCostSavings: '80%'
      },
      legalAssistant:{
        phSalary:{
          yearOneTwo: 700,
          yearThreeFive: 1000,
          yearFivePlus:1300
        },
        usSalary:{
          yearOneFivePlus: {
            range1: 3800,
            range2: 8700
          }
        },
        estimatedCostSavings: '79%'
      },
      operationsManager:{
        phSalary:{
          yearOneTwo: 1000,
          yearThreeFive: 1500,
          yearFivePlus:2000
        },
        usSalary:{
          yearOneFivePlus: {
            range1: 4200,
            range2: 13000
          }
        },
        estimatedCostSavings: '77%'
      },
      businessAnalyst:{
        phSalary:{
          yearOneTwo: 700,
          yearThreeFive: 1000,
          yearFivePlus:1300
        },
        usSalary:{
          yearOneFivePlus: {
            range1: 3900,
            range2: 7000
          }
        },
        estimatedCostSavings: '76%'
      },
      projectManager:{
        phSalary:{
          yearOneTwo: 800,
          yearThreeFive: 1100,
          yearFivePlus:1700
        },
        usSalary:{
          yearOneFivePlus: {
            range1: 4500,
            range2: 12500
          }
        },
        estimatedCostSavings: '80%'
      },
      productDevManager:{
        phSalary:{
          yearOneTwo: 1000,
          yearThreeFive: 1300,
          yearFivePlus:2100
        },
        usSalary:{
          yearOneFivePlus: {
            range1: 5200,
            range2: 15000
          }
        },
        estimatedCostSavings: '79%'
      },
      inventoryManager:{
        phSalary:{
          yearOneTwo: 1000,
          yearThreeFive: 1300,
          yearFivePlus:1600
        },
        usSalary:{
          yearOneFivePlus: {
            range1: 5000,
            range2: 8000
          }
        },
        estimatedCostSavings: '75%'
      },
      supplyChainAnalyst:{
        phSalary:{
          yearOneTwo: 800,
          yearThreeFive: 1100,
          yearFivePlus:1500
        },
        usSalary:{
          yearOneFivePlus: {
            range1: 4000,
            range2: 7500
          }
        },
        estimatedCostSavings: '74%'
      },
      logisticsSpecialist:{
        phSalary:{
          yearOneTwo: 800,
          yearThreeFive: 1000,
          yearFivePlus:1400
        },
        usSalary:{
          yearOneFivePlus: {
            range1: 3500,
            range2: 7500
          }
        },
        estimatedCostSavings: '75%'
      }
    }
  }

